import { ReactiveFormsModule, FormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { NgModule } from '@angular/core'

import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { ConfirmDialogModule } from 'primeng/confirmdialog'
import { InputTextareaModule } from 'primeng/inputtextarea'
import { InputNumberModule } from 'primeng/inputnumber'
import { InputSwitchModule } from 'primeng/inputswitch'
import { InputTextModule } from 'primeng/inputtext'
import { SkeletonModule } from 'primeng/skeleton'
import { TooltipModule } from 'primeng/tooltip'
import { ButtonModule } from 'primeng/button'
import { DialogModule } from 'primeng/dialog'
import { TableModule } from 'primeng/table'
import { ToastModule } from 'primeng/toast'
import { OverlayPanelModule } from 'primeng/overlaypanel'
import { TagModule } from 'primeng/tag'

import { AlgorithmConfigDetailComponent } from './components/algorithm-config-detail/algorithm-config-detail.component'
import { AlgorithmConfigListComponent } from './components/algorithm-config-list/algorithm-config-list.component'
import { ConfigTierEditorComponent } from './components/config-tier-editor/config-tier-editor.component'
import { SharedModule } from '@shared/shared.module'

@NgModule({
  declarations: [AlgorithmConfigListComponent, AlgorithmConfigDetailComponent, ConfigTierEditorComponent],
  imports: [
    CommonModule,
    //* Para los `routerLink` que llevan de la ayuda contextual al manual de Documentación.
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    DialogModule,
    ConfirmDialogModule,
    InputTextModule,
    InputTextareaModule,
    InputNumberModule,
    InputSwitchModule,
    TableModule,
    TagModule,
    ToastModule,
    TooltipModule,
    OverlayPanelModule,
    SkeletonModule,
    ProgressSpinnerModule,
    SharedModule,
  ],
})
export class AlgorithmConfigModule {}
